import axios from 'axios'
const state = {
  data: {
    name: '',
    country: '',
    country_code: '',
    email: '',
    phone: '',
    vat_no: '',
    zip_code: '',
    description: '',
    adr_city: '',
    adr_street: '',
    adr_no: '',
    adr_zip: '',
    company_code: '',
    website: ''
  }
}

const mutations = {
  setData(state, data) {
    state.data.name = data.name
    state.data.country = data.country
    state.data.country_code = data.country_code
    state.data.email = data.email
    state.data.phone = data.phone
    state.data.vat_no = data.vat_no
    state.data.zip_code = data.zip_code
    state.data.description = data.description
    state.data.adr_city = data.adr_city
    state.data.adr_street = data.adr_street
    state.data.adr_no = data.adr_no
    state.data.adr_zip = data.adr_zip
    state.data.company_code = data.company_code
    state.data.website = data.website
  },
  emptyFields(state, data) {
    state.data.name = ''
    state.data.country = ''
    state.data.country_code = ''
    state.data.email = ''
    state.data.phone = ''
    state.data.vat_no = ''
    state.data.zip_code = ''
    state.data.description = ''
    state.data.adr_city = ''
    state.data.adr_street = ''
    state.data.adr_no = ''
    state.data.adr_zip = ''
    state.data.company_code = ''
    state.data.website = ''
  }
}

const getters = {
  data(state) {
    return state.data
  }
}

const actions = {
  postCompanyData({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/account/companies',
        data: state.data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
